<template>
  <div class="wrap_box">
    <h3>
      <img src="../../assets/img/logo.png" v-if="operatorName == '智充'">
    </h3>
    <div class="regis_wrap">
      <div class="regis">
        <div class="left">
          <el-steps class="steps" finish-status="success" process-status="process " :active="stepActive" simple>
            <el-step :title="$t('resetPassword_00001')">
              <div class="num" slot="icon">1</div>
            </el-step>
            <el-step :title="$t('resetPassword_00002')">
              <div class="num" slot="icon">2</div>
            </el-step>
            <el-step :title="$t('resetPassword_00003')">
              <div class="num" slot="icon">3</div>
            </el-step>
          </el-steps>
        </div>
        <div class="right">
          <!-- 信息验证 -->
          <div class="step_two" v-show="stepActive==0">
            <el-form :model="ruleForm" ref="ruleForm" class="regin-info" :rules="rules">
              <div class="title">{{$t('resetPassword_00004')}}</div>
              <el-form-item class="input" prop="acount">
                <el-input class="inp" :placeholder="$t('resetPassword_00005')" v-model="ruleForm.acount"></el-input>
              </el-form-item>
              <div class="title">{{product =='cn' ? $t('resetPassword_00006') : $t('resetPassword_00040')}}</div>
              <el-row class="input">
                <el-col :span="17">
                  <el-form-item prop="contactMobile">
                    <el-input class="inp code" :placeholder="product =='cn' ? $t('resetPassword_00008') :$t('resetPassword_00041')" v-model="ruleForm.contactMobile"></el-input>
                  </el-form-item>
                </el-col>
                <el-col align="right" :span="6" :offset="1">
                  <el-button type="primary" @click="sendCode" id="code" :disabled="sendFlag">{{$t('resetPassword_00009')}}</el-button>
                </el-col>
              </el-row>
              <div class="title">{{product =='cn' ? $t('resetPassword_00011') : $t('resetPassword_00044')}}</div>
              <el-form-item class="input" prop="smsAuthCode">
                <el-input class="inp" :placeholder="product =='cn' ? $t('resetPassword_00013') : $t('resetPassword_00045')" v-model="ruleForm.smsAuthCode"></el-input>
              </el-form-item>
              <el-form-item>
                <div class="btn">
                  <el-button type="primary" :disabled="!ruleForm.acount||!ruleForm.contactMobile||!ruleForm.smsAuthCode" @click="confirmSmsauthcode">{{$t('resetPassword_00014')}}</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 修改密码 -->
          <div class="step_two" v-show="stepActive==1">
            <el-form :model="ruleForm1" ref="ruleForm2" class="regin-info" :rules="rules">
              <div class="title">{{$t('resetPassword_00015')}} <span>( {{$t('resetPassword_00016')}} )</span></div>
              <el-form-item class="input" prop="password">
                <el-input class="inp" :placeholder="$t('resetPassword_00017')" v-model="ruleForm1.password" :type="flag1?'text':'password'">
                  <img slot="suffix" :src="flag1?require('../../assets/img/login/eyes.png'):require('../../assets/img/login/eye.png')" @click="flag1=!flag1"></img>
                </el-input>
              </el-form-item>
              <div class="title">{{$t('resetPassword_00018')}} <span>( {{$t('resetPassword_00019')}} )</span></div>
              <el-form-item class="input" prop="passwordRe">
                <el-input class="inp" :placeholder="$t('resetPassword_00020')" v-model="ruleForm1.passwordRe" :type="flag2?'text':'password'">
                  <img slot="suffix" :src="flag2?require('../../assets/img/login/eyes.png'):require('../../assets/img/login/eye.png')" @click="flag2=!flag2"></img>
                </el-input>
              </el-form-item>
              <el-form-item>
                <div class="btn">
                  <el-button type="primary" :disabled="!ruleForm1.password||!ruleForm1.passwordRe" @click="resetpassword">{{$t('resetPassword_00021')}}</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 完成修改 -->
          <div class="step_one last" v-show="stepActive==2">
            <img src="../../assets/img/success_2.png" alt="">
            <p>{{$t('resetPassword_00022')}}</p>
            <a href="./login.html" class="btn">
              <el-button type="primary" v-if="isGroupUser">登录集团运营商平台</el-button>
              <el-button type="primary" v-else>{{$t('resetPassword_00023')}}</el-button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { operator, isGroupWebsite } from "@/assets/utils/constants";
import {
  requestUrl,
  ajax,
  checkLogin,
  getQueryString,
} from "@/assets/utils/network";
export default {
  data() {
    var product = '';

    // 验证验证码是否正确
    var checkcode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("resetPassword_00024")));
      } else if (isNaN(value)) {
        callback(new Error(this.$t("resetPassword_00025")));
      } else if (value.toString().length !== 6) {
        callback(new Error(this.$t("resetPassword_00026")));
      } else {
        callback();
      }
    };
    // 验证密码：6-20位，且至少包含1个数字及1个字母以及1个特殊字符
    var checkpassO = (rule, value, callback) => {
      let reg =
        /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[\x20-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E])[\x20-\x7E]{6,20}$/;
      if (value === "") {
        callback(new Error(this.$t("resetPassword_00032")));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t("resetPassword_00039")));
      } else {
        callback();
      }
    };
    // 验证密码是否一致
    var checkpass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("resetPassword_00027")));
      } else if (value !== this.ruleForm1.password) {
        callback(new Error(this.$t("resetPassword_00028")));
      } else {
        callback();
      }
    };
    // 验证手机号
    var checkMobile = (rule, value, callback) => {
      var reg;
      if(this.product != 'cn'){
        console.log('checkEmail')
        reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (value === "") {
          callback(new Error(this.$t("resetPassword_00041")));
        } else if (!reg.test(value)) {
          callback(new Error(this.$t("resetPassword_00042")));
        } else {
          callback();
        }

      }  else {
        reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (value === "") {
          callback(new Error(this.$t("resetPassword_00029")));
        } else if (!reg.test(value)) {
          callback(new Error(this.$t("resetPassword_00030")));
        } else {
          callback();
        }
      }
    };
    // 验证邮箱
    var checkEmail = (rule, value, callback) => {
      console.log('yyy')
      let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      if (value === "") {
        callback(new Error(this.$t("resetPassword_00041")));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t("resetPassword_00042")));
      } else {
        callback();
      }
    };
    return {
      isGroupUser: false,
      operatorName: '',
      product: "",
      stepActive: 0, // 步骤条 -- 激活第几个
      // 信息验证
      interval: null,
      cutDown: false,
      code: "", // 验证码验证成功
      flag1: false, // 密码
      flag2: false, // 密码
      ruleForm: {
        acount: "",
        contactMobile: "",
        smsAuthCode: "",
      },
      ruleForm1: {
        password: "",
        passwordRe: "",
      },
      rules: {
        // 校验规则
        acount: [
          {
            required: true,
            message: this.$parent.$t("resetPassword_00031"),
            trigger: "blur",
          },
        ],
        password: [
          {
            validator: checkpassO,
            trigger: "blur",
          },
        ],
        passwordRe: [
          {
            validator: checkpass,
            trigger: "blur",
          },
        ],
        contactMobile: [
          {
            validator: checkMobile,
            trigger: "blur",
          },
        ],
        // 短信验证码
        smsAuthCode: [
          {
            validator: checkcode,
            trigger: "blur",
          },
        ],
      },
      errorCode: {
        BAD_MOBILE: this.$parent.$t("resetPassword_00034"),
        BAD_AUTH_CODE: this.$parent.$t("resetPassword_00035"),
        INVALID_AUTH_CODE: this.$parent.$t("resetPassword_00036"),
        TIMEOUT_AUTH_CODE: this.$parent.$t("resetPassword_00037"),
        BAD_EMAIL: this.$parent.$t("resetPassword_00042"),
        BAD_BIND: this.$parent.$t("resetPassword_00043"),


      },
    };
  },
  computed: {
    // 发送手机验证码的开关
    sendFlag() {
      if (this.cutDown) {
        return true;
      }
      let { acount, contactMobile } = this.ruleForm;
      if(this.product == 'cn') {
        if (acount && contactMobile && contactMobile.length == 11) {
          return false;
        }
      } else {
        let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (acount && contactMobile  && reg.test(contactMobile)) {
        return false;
      }
      }
      return true;
    },
  },
  created() {
    window.document.title = this.$t("resetPassword_00038");
    this.product = window.product_area;
    this.operatorName = operator;
    this.isGroupUser = isGroupWebsite;
  },
  methods: {
    // 发送验证码
    async sendCode() {
      let { acount, contactMobile } = this.ruleForm;
      let reg;
      if(this.product == 'cn'){
        reg= /^[1][3,4,5,7,8,9][0-9]{9}$/;
      } else {
        reg=  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      }
      if (!acount || !contactMobile || !reg.test(contactMobile)) return;

      let info = new Object();
     
      info.loginId = this.ruleForm.acount;
      info.platform = 1;

      if(this.product == 'cn') {
        info.mobile = this.ruleForm.contactMobile;
      } else {
        info.email = this.ruleForm.contactMobile;
      }
      let res =  this.product == 'cn' ?  await this.checkTel(info) : await this.checkMail(info);
        console.log('sdfgdfgdf',res)
      if (res.error) {
        if (this.errorCode[res.error.code]) {
          this.$message.error(this.errorCode[res.error.code]);
        } else {
          this.$message.error(res.error.msg);
        }
        return;
      }
      let time_num = 60;
      let that = this;
      this.cutDown = true;
      this.interval = setInterval(function () {
        if (--time_num < 1) {
          clearInterval(that.interval);
          that.cutDown = false;
          document
            .getElementById("code")
            .getElementsByTagName("span")[0].innerText = that.$t(
            "resetPassword_00009"
          );
        } else document.getElementById("code").getElementsByTagName("span")[0].innerText = that.$t("resetPassword_00010", [time_num]);
      }, 1000);
    },
    //验证邮箱绑定关系
    checkMail(info) {
      console.log('mail')
      return new Promise((resovle, reject) => {
        ajax({
          type: "POST",
          url: requestUrl + "/emailAutoCode",
          data: JSON.stringify(info),
          dataType: "json",
          success: (response) => {
            let res = JSON.parse(response);
            resovle(res);
          },
        });
      });
    },
    //验证手机号绑定关系
    checkTel(info) {
      return new Promise((resovle, reject) => {
        ajax({
          type: "POST",
          url: requestUrl + "/smsauthcode",
          data: JSON.stringify(info),
          dataType: "json",
          success: (response) => {
            let res = JSON.parse(response);
            resovle(res);
          },
        });
      });
    },
    // 验证验证码
    confirmSmsauthcode() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        let { contactMobile, smsAuthCode,acount } = this.ruleForm;
        var info = {
            authCode: smsAuthCode,
        };
        let url;
        // 信息验证国内国际环境接口区分
        if(this.product == 'cn') {
          url = requestUrl + "/smsauthcode/confirm"
          info.mobile = contactMobile
        } else {
          url = requestUrl + "/emailAutoCode/confirm"
          info.email = contactMobile
          info.loginId = acount;


        }

        ajax({
          type: "POST",
          url: url,
          data: JSON.stringify(info),
          dataType: "json",
          success: (response) => {
            let res = JSON.parse(response);
            if (res.error) {
              if (this.errorCode[res.error.code]) {
                console.log('safds',res.error.code)
                this.$message.error(this.errorCode[res.error.code]);
              }
              return false;
            }
            if (res.result) {
              this.code = res.result;
              this.stepActive = 1;
            }
          },
        });
      });
    },
    // 修改密码
    resetpassword() {
      this.$refs.ruleForm2.validate((valid) => {
        if (!valid) return;
        let info = {
          loginId: this.ruleForm.acount,
          code: this.code,
          password: this.ruleForm1.passwordRe,
          platform: 1,
        };
        let url;
        // 国内国际环境接口区分
        if(this.product == 'cn') {
          url =requestUrl + "/smsauthcode/resetpassword"
        } else {
          url =requestUrl + "/emailAutoCode/resetpassword"
        }
        ajax({
          type: "POST",
          url: url,
          data: JSON.stringify(info),
          dataType: "json",
          success: (response) => {
            let res = JSON.parse(response);
            if (res.error) {
              if (this.errorCode[res.error.code]) {
                this.$message.error(this.errorCode[res.error.code]);
              }
              if (
                ["INVALID_AUTH_CODE", "TIMEOUT_AUTH_CODE"].includes(
                  res.error.code
                )
              ) {
                this.stepActive = 0;
              }
              return false;
            }
            this.stepActive = 2;
          },
        });

      });
    },
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/reset.css";
@import "./style.scss";
</style>